module.exports = __webpack_public_path__ + "assets/img/point_icon1.2298d035.png";